<template>
  <div class="search__result">
    <div class="btn_wrap">
      <button
        class="btn"
        @click="checkApply('MOBILE_APPLY')"
        v-if="isMobileBtn"
      >
        <i class="i_perce_w"></i>휴대폰 견적 신청하기
      </button>
      <button
        class="btn"
        @click="checkApply('INTERNET_APPLY')"
        v-if="isInternetBtn"
      >
        <i class="i_internet_w"></i>인터넷 혜택 견적 신청하기
      </button>
    </div>
    <ul class="search__result__list">
      <!-- 매장 -->
      <li class="search__result__item" v-if="data.stores?.length > 0">
        <div class="item__inner">
          <ResultTitle
            :type="'STORE'"
            :count="data.storeCnt"
            @more="viewMore"
          />
          <ul class="store_list_wrap">
            <StoreItem
              v-for="item in data.stores"
              :key="item.id"
              :data="item"
            />
          </ul>
        </div>
      </li>

      <!-- 퍼스 지식인 -->
      <li class="search__result__item" v-if="data.knowhows?.length > 0">
        <div class="item__inner">
          <ResultTitle
            :type="'KNOWHOW'"
            :count="data.knowhowCnt"
            @more="viewMore"
          />
          <ul class="board__list">
            <BoardItem
              v-for="item in data.knowhows"
              :key="item.id"
              :data="item"
              :type="'KNOWHOW'"
            />
          </ul>
        </div>
      </li>

      <!-- 자유게시판 -->
      <!-- <li class="search__result__item" v-if="data.boards?.length > 0">
        <div class="item__inner">
          <ResultTitle
            :type="'BOARD'"
            :count="data.boardCnt"
            @more="viewMore"
          />
          <ul class="board__list">
            <BoardItem
              v-for="item in data.boards"
              :key="item.id"
              :data="item"
              :type="'BOARD'"
            />
          </ul>
        </div>
      </li> -->

      <!-- 리뷰 -->
      <li class="search__result__item" v-if="data.reviews?.length > 0">
        <div class="item__inner">
          <ResultTitle
            :type="'REVIEW'"
            :count="data.reviewCnt"
            @more="viewMore"
          />
          <ul class="comment_list">
            <ReviewItem
              v-for="item in data.reviews"
              :key="item.id"
              :data="item"
            />
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import ResultTitle from './ResultTitle.vue';
import StoreItem from './StoreItem.vue';
import BoardItem from './BoardItem.vue';
import ReviewItem from './ReviewItem.vue';

export default {
  name: 'components-search-result',
  description: '검색 페이지 > 검색 결과 리스트',
  components: {
    ResultTitle,
    StoreItem,
    BoardItem,
    ReviewItem,
  },
  props: {
    data: Object,
    isMobileBtn: Boolean,
    isInternetBtn: Boolean,
  },
  methods: {
    viewMore(type) {
      const query = { keyword: this.$route.query.keyword };
      if (type === 'STORE') {
        this.$router.push({ name: 'Shops.search', query: query });
      } else if (type === 'KNOWHOW') {
        this.$router.push({ name: 'Knowhow.List', query: query });
      } else if (type === 'BOARD') {
        this.$router.push({ name: 'Board.List', query: query });
      } else if (type === 'REVIEW') {
        this.$router.push({ name: 'Search.Reviews', query: query });
      }
    },
    checkApply(type) {
      this.$emit('check-apply', type);
    },
  },
};
</script>
<style scoped></style>
